<template>
  <router-view class="admin"></router-view>
</template>

<script>
  export default {
    name: 'admin-index',
  };
</script>
